// extracted by mini-css-extract-plugin
export default {"root":"Ranking_root__MC8RM","star":"Ranking_star__1Gee9","hovered":"Ranking_hovered__2vpO8","selected":"Ranking_selected__HrXXM"};